var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorBoundry1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 416,
    viewBox: "0 0 399 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399 203.888C399 304.752 291.813 300.388 186.618 386.519C99.3539 457.968 -24.1699 400.476 4.12117 203.888C11.6917 93.0337 51.1397 150.854 186.618 21.2565C296.594 -58.097 399 103.023 399 203.888Z",
    fill: "url(#paint0_linear_6777_61257)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6777_61257",
    x1: -80.9565,
    y1: -253.5,
    x2: 441.3,
    y2: -233.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBoundry1);
export default __webpack_public_path__ + "static/media/errorBoundry1.2ba3ef426aa11988867a4900cc777420.svg";
export { ForwardRef as ReactComponent };